import React, { useState, useEffect } from 'react';
import { isMobileDevice } from '../../../common/utilities/utils';
import PrivacyHeader from '../Presentation/PrivacyHeader';
import PrivacyDescription from '../Presentation/PrivacyDescription';
import PrivacyQuestions from '../Presentation/PrivacyQuestions';

const PrivacyPolicyContainer = props => {
  const { contentData = {}, userParams } = props;
  const { headerData = {}, description = {}, questionList = [] } = contentData;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);
  const desktopPrivacyPolicy = () => {
    return (
      <div className='privacy-desktop-container'>
        <div className='privacy-section-left'>
          <PrivacyHeader headerData={headerData} userParams={userParams} />
        </div>
        <div className='privacy-section-right'>
          <div className='privacy-description-desktop'>
            <PrivacyDescription description={description} />
          </div>
          <div className='privacy-questions-desktop'>
            <PrivacyQuestions questionList={questionList} />
          </div>
        </div>
      </div>
    );
  };
  const mobilePrivacyPolicy = () => {
    return (
      <div className='privacy-mobile-container'>
        <div className='privacy-mobile-header'>
          <PrivacyHeader headerData={headerData} />
        </div>
        <div className='privacy-mobile-description'>
          <PrivacyDescription description={description} />
        </div>
        <div className='privacy-mobile-questions'>
          <PrivacyQuestions questionList={questionList} />
        </div>
      </div>
    );
  };
  return isMobile ? mobilePrivacyPolicy() : desktopPrivacyPolicy();
};
export default PrivacyPolicyContainer;
